import { differenceInDays, parseISO } from 'date-fns';

// Key = minimum number of nights to qualify for that discount
export const LENGTH_OF_STAY_DISCOUNT_LABELS = {
  0: 'Rental Discount',
  7: 'Weekly Discount',
  14: 'Multi-Week Discount',
  30: 'Monthly Discount',
};
export function getLengthOfStayDiscount(
  check_in: string,
  check_out: string
): string {
  const lengthOfStay = differenceInDays(
    parseISO(check_out),
    parseISO(check_in)
  );
  const thresholds = Object.keys(LENGTH_OF_STAY_DISCOUNT_LABELS).map(Number);

  // Find the highest threshold that is less than or equal to the stay
  const maxThreshold = thresholds
    .filter((t) => lengthOfStay >= t)
    .sort((a, b) => b - a)[0];

  return (
    LENGTH_OF_STAY_DISCOUNT_LABELS[
      maxThreshold as keyof typeof LENGTH_OF_STAY_DISCOUNT_LABELS
    ] ?? LENGTH_OF_STAY_DISCOUNT_LABELS[0]
  );
}
